export const immediateModules = [
  { code: 'il_wallet', label: '全口充值与钱包', path: '/immediate-loading/fullarch-billing', index: 'fullArchBilling' },
  { code: 'il_slice', label: '切片任务', path: '/immediate-loading/print/slice-tasks', index: 'printAdmin0' },
  { code: 'il_device', label: '设备管理', path: '/immediate-loading/print/devices', index: 'printAdmin1' },
  { code: 'il_send', label: '发送记录', path: '/immediate-loading/print/deliveries', index: 'printAdmin2' },
  { code: 'il_reg', label: '注册审核', path: '/immediate-loading/registrations', index: 'immediateLoadingRegistrations' },
  { code: 'il_redeem', label: '兑换码管理', path: '/immediate-loading/redeem', index: 'immediateLoadingRedeem' },
  { code: 'il_users', label: '用户管理', path: '/immediate-loading/users', index: 'immediateLoadingUsers' },
  { code: 'il_tasks', label: '任务管理', path: '/immediate-loading/tasks', index: 'immediateLoadingTasks' }
]
export const immediateRole = user => Boolean(user && user.remark === '8')
export const canAccessImmediate = (user, path) => {
  if (user && user.remark === '0') return true
  const module = immediateModules.find(item => item.path === path)
  return immediateRole(user) && Boolean(module) && (user.permissionCodes || []).includes(module.code)
}
export const firstImmediatePath = user => {
  const module = immediateModules.find(item => canAccessImmediate(user, item.path))
  return module ? module.path : '/login'
}



// WEBPACK FOOTER //
// ./src/assets/utils/immediateLoadingPermissions.js